var React = require('react');

function FullCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.5,0.7c-2.6,0-4.8,2.1-4.8,4.8s2.1,4.8,4.8,4.8s4.8-2.1,4.8-4.8S8.1,0.7,5.5,0.7z"}));
}

FullCircle.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 11 11","style":{"enableBackground":"new 0 0 11 11"},"xmlSpace":"preserve"};

module.exports = FullCircle;

FullCircle.default = FullCircle;
